<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Upload Exam Result
    </button>

    <a-modal v-model="visible" title="Upload Exam Result" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Upload</a-button>
      </template>

      <a-form :form="form">
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item label="Exam Name">
              <a-input
                placeholder="Enter exam name"
                v-decorator="['exam_name', {rules: [{ required: true, message: 'Please input exam name!'},{ max: 20, message: 'Maximum 20 characters allowed' }]}]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6 mb-2">
            <p class="font-weight-bold text-dark mb-2">Notification Channels:</p>
            <a-radio-group v-model="selectedType" @change="handleRadioChange">
              <a-radio :value="option.value" v-for="option in sendOptions" :key="option.value">
                {{ option.label }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-md-4" v-if="selectedType == 'sms'">
            <a-form-item label="SMS Template">
              <a-select
                v-decorator="['sms_template_id', {rules: [{ required: true, message: 'Please select a template!'}]}]"
                placeholder="Choose SMS Template"
                :defaultValue="0"
                @change="handleSmsTemplateChange"
              >
                <a-select-option :value="0" disabled>
                  Choose SMS Template
                </a-select-option>
                <a-select-option
                  v-for="item in smsTemplates"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.template_name }}
                </a-select-option>
            </a-select>
            </a-form-item>
          </div>
        </div>
        <a-form-item label="SMS template preview:" v-if="selectedType == 'sms'">
          <a-textarea
            v-model="smsTemplateMessage"
            style="color: #000000"
            :autoSize="{ minRows: 2 }"
            :disabled="true"
            :defaultValue="0"
          />
        </a-form-item>
        <a-form-item label="Sample message:">
          <a-textarea
            v-model="sampleMessage"
            style="color: #000000"
            :autoSize="{ minRows: 2 }"
            :disabled="true"
            :defaultValue="0"
          />
        </a-form-item>
        <p class="mt-3 mb-0">Download the csv file format here.
          <a
            href="/resources/csv/exam_marks_upload.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Exam Result
          </a>
          <span class="font-weight-bold text-warning">Fields marked with * are required!</span>
        </p>
        <p class="text-danger">Note: Fill the marks in the CSV file in the order of the subject names present in the selected SMS template.</p>
        <div class="row">
          <div class="col-md-4">
            <a-form-item
              label="Upload CSV File"
            >
              <a-upload
                v-decorator="['file', {rules: [{ required: true, message: 'Please select a csv file to upload!' }]}]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

const sendOptions = [
  { label: 'App', value: 'push' },
  // { label: 'Email', value: 'email' },
  { label: 'SMS', value: 'sms' },
]

const sampleMessage = 'Dear Ananya Gupta (ID:4735), your marks for the 1st test exam are: Physics:10,Chemistry:20,Botany:30,Zoology:78,Total:138. Thanks.'
export default {
  name: 'BulkSMSExamResultSend',
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedSession: undefined,
      classSpinning: false,
      sectionSpinning: false,
      smsTemplates: [],
      smsTemplateMessage: '',
      sampleMessage: '',
      sendOptions,
      selectedType: 'push',
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.getSMSTemplates()
      if (this.selectedType === 'push') {
        this.sampleMessage = sampleMessage
      }
    },
    getSMSTemplates() {
      this.$http.get('/api/sms/templates')
        .then(({ data }) => {
          this.smsTemplates = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleRadioChange(checkedValues) {
      this.sampleMessage = ''
      if (this.selectedType === 'push') {
        this.sampleMessage = sampleMessage
      }
    },
    handleSmsTemplateChange(smsTemplateId) {
      const selectedTemplate = (this.smsTemplates.filter((smsTemplate) => smsTemplate.id === smsTemplateId))[0]
      this.smsTemplateMessage = selectedTemplate.template
      this.sampleMessage = selectedTemplate.sample_msg
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload (file) {
      const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['section_id'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.form.resetFields(['class_id', 'section_id'])

      this.getClasses()
    },
    getAction(actionValue) {
      if (actionValue === 0) return 'ADD_STAFF'
      if (actionValue === 1) return 'UPDATE_STAFF'
      if (actionValue === 2) return 'UPSERT_SUBJECT'
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        values['action'] = this.getAction(values['action'])
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to upload exam results!`,
            onOk: () => {
              let formData = window.jsonToFormData(values, options)
              const csvFile = values.file.file
              formData.append('file', csvFile)
              formData.append('push', this.selectedType === 'push' ? 1 : 0)
              this.$http
                .post('/api/notifications/send/examresults', formData)
                .then(({ data }) => {
                  this.$emit('uploaded')
                  this.$eventBus.$emit('calendarEventUpdated')
                  this.loading = false
                  this.visible = false
                  this.$notification['info']({
                    message: 'Bulk upload started!',
                    description: `Bulk exam result upload has started for sending SMS! You can start checking the status of the SMS.`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
